export default __webpack_public_path__ + "images/UN.6b78d9c.png";